import React, { Component } from "react";

import {
  View,
  AppState,
  AppStateStatus,
  NativeEventSubscription,
} from "react-native";
import Text from "components/Text";
import moment from "jalali-moment";

import { colors } from "assets/constants";
import { mq } from "utils";
import css from "styles";

type propsType = {
  expireDate?: string;
  duration: number;
  onFinish?(): void;
  hideHour?: boolean;
};

const convertTime = (exp: string) => {
  const d = new Date(exp);
  const now = Date.now();
  const expireDate = moment(d, "YYYY-MM-DD HH:mm:ss");
  return Math.floor((expireDate.toDate().getTime() - now) / 1000);
};

export default class Timer extends Component<propsType> {
  timer: ReturnType<typeof setInterval> | null;
  subscription: NativeEventSubscription | null;

  constructor(props: propsType) {
    super(props);
    this.timer = null;
    this.subscription = null;
  }

  state = {
    isCurrent: true,
    duration: 0,
    wentBackgroundAt: 0,
  };

  initialTimer = () => (this.timer = setInterval(this.updateTime, 1000));

  updateTime = () => {
    if (this.state.duration <= 1) {
      this.setState({ duration: 1 });
      this.timer && clearInterval(this.timer);
      setTimeout(() => {
        this.props.onFinish && this.props.onFinish();
      });
    }
    this.setState({ duration: this.state.duration - 1 });
  };

  handleAppStateChange = (currentState: AppStateStatus) => {
    if (currentState === "active") {
      const diff = Math.floor(
        (Date.now() - this.state.wentBackgroundAt) / 1000
      );
      const res = this.state.duration - diff;
      this.setState({ duration: res });
    }

    if (currentState === "background") {
      this.setState({ wentBackgroundAt: Date.now() });
    }
  };

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        duration: this.props.duration
          ? this.props.duration
          : convertTime(this.props.expireDate || ""),
      });
    }, 30);

    this.subscription = AppState.addEventListener(
      "change",
      this.handleAppStateChange
    );

    this.state.isCurrent && this.initialTimer();
  }

  componentWillUnmount() {
    this.setState({ isCurrent: false });
    this.subscription?.remove();
    this.timer && clearInterval(this.timer);
  }

  render() {
    const { duration } = this.state;

    const hour = Math.floor(duration / 3600);
    const minute = Math.floor((duration % 3600) / 60);
    const second = Math.floor((duration % 3600) % 60);

    return (
      <View style={[css.rowCenterAlign, css.selfStart]}>
        {!this.props.hideHour && (
          <View style={[css.centralElements, { width: mq(30) }]}>
            <Text color={colors.textColorDefault} weight="bold" size={"xl"}>
              {hour < 10 ? `0${hour}` : hour}
            </Text>
          </View>
        )}

        {!this.props.hideHour && (
          <Text
            color={colors.textColorDefault}
            weight="bold"
            size={"xl"}
            align="center"
          >
            :
          </Text>
        )}

        <View style={[css.centralElements, { width: mq(30) }]}>
          <Text color={colors.textColorDefault} weight="bold" size={"xl"}>
            {minute < 10 ? `0${minute}` : minute}
          </Text>
        </View>

        <Text
          color={colors.textColorDefault}
          weight="bold"
          size={"xl"}
          align="center"
        >
          :
        </Text>

        <View style={[css.centralElements, { width: mq(30) }]}>
          <Text color={colors.textColorDefault} weight="bold" size={"xl"}>
            {second < 10 ? `0${second} ` : second}
          </Text>
        </View>
      </View>
    );
  }
}
